<template>
  <div class="fill_form mt20 m0 mb30 clearfix" key="workerSee">
    <ul class="fr operation_list">
      <li class="fl"><router-link :to="{name:'add',params:{type:'worker',index:'0',status:'edit',id:id}}">修改</router-link></li>
      <li class="fl" @click="delPerson">删除</li>
      <li class="fl" @click="gotoOther('retire')">转退休</li>
      <!--<router-link :to="{name:'add',params:{type:'retire',index:'1',status:'edit',id:id}}">转退休</router-link>-->
      <li class="fl" @click="gotoOther('leaver')">转离职</li>
      <!--<router-link :to="{name:'add',params:{type:'leaver',index:'2',status:'edit',id:id}}">转离职</router-link>-->
    </ul>
    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>基本信息
    </h3>

    <!-- 标题 end-->
    <div class="fill_group_row clearfix fl w_half">

      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>姓名</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input time_icon" disabled id="lord_company" v-model="userInfo.user.username" type="text"/>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>性别</label>
        <div class="form_control w_auto ">
          <select class="i_w300 form_select time_icon" disabled v-model="userInfo.user.sex">
            <option value="1">男</option>
            <option value="2">女</option>
          </select>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>民族</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input time_icon" disabled v-model="userInfo.user.nation" type="text"/>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>参加工作日期</label>
        <div class="form_control w_auto ">
          <vue-datepicker-local class="i_w300 form_input date_picker_out" disabled v-model="userInfo.user.work_time" name="date"></vue-datepicker-local>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>工作单位</label>
        <div class="form_control w_auto ">
          <select class="i_w300 form_select" name="companyName" type="text" disabled v-model="userInfo.user.company_id">
            <option value="0">请选择单位</option>
            <option :value="item.id" v-for="(item,index) in companyData">{{item.company_name}}</option>
          </select>
        </div>
      </div>

    </div>
    <div class="fill_group_row clearfix fr w_half">

      <div class="form_group clearfix">
        <!--<label class="control_label "><em>*</em>居民身份证</label>-->
        <label class="control_label "><em>*</em>社会保障号</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input time_icon" disabled id="" type="text" v-model="userInfo.user.social_security_account"/>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>出生日期</label>
        <div class="form_control w_auto ">
          <vue-datepicker-local class="i_w300 form_input date_picker_out" v-model='userInfo.user.birthday' disabled name="date"></vue-datepicker-local>
        </div>
      </div>
      <!--<div class="form_group clearfix">-->
        <!--<label class="control_label "><em>*</em>工作单位</label>-->
        <!--<div class="form_control w_auto ">-->
          <!--<input class="i_w300 form_input" type="text" disabled v-model='userInfo.user.work_unit_name'/>-->
        <!--</div>-->
      <!--</div>-->
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>邮政编码</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input" type="text" disabled v-model='userInfo.user.postal_code'/>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>联系手机</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input" disabled type="text" v-model="userInfo.user.mobile" />
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label ">固定电话</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input"  type="text" disabled v-model='userInfo.user.telephone'/>
        </div>
      </div>
    </div>
    <div class="fill_group_row clearfix">
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>户籍所在地</label>
        <div class="form_control w_auto">

          <div class="flex fl">
            <div class="w_375">
              <select class="form_select s_w120" name="" disabled v-model='userInfo.user.domicile_province'>
                <option value="">省</option>
                <option v-for="(item,index) in areas.allArr" :value="index">
                  {{item.name}}
                </option>
              </select>
              <select class="form_select s_w120" name="" disabled v-model='userInfo.user.domicile_city'>
                <option value="">市</option>
                <option v-for="(item,index) in areas.domicileCities" :value="index">{{item.name}}</option>
              </select>
              <select class="form_select s_w120" name="" disabled v-model='userInfo.user.domicile_district'>
                <option value="">区</option>
                <option v-for="(item,index) in areas.domicileDistrict" :value="index">{{item.name}}</option>
              </select>
            </div>
            <div class="auto_flex">
              <input class=" form_input time_icon w100" disabled type="text"  v-model='userInfo.user.domicile_detail'/>
            </div>

          </div>

        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>通讯地址</label>
        <div class="form_control w_auto">

          <div class="flex fl">
            <div class="w_375">
              <select class="form_select s_w120" disabled name="" v-model="userInfo.user.address_province">
                <option value="">省</option>
                <option v-for="(item,index) in areas.allArr" :value="index">
                  {{item.name}}
                </option>
              </select>
              <select class="form_select s_w120" disabled name="" v-model="userInfo.user.address_city">
                <option value="">市</option>
                <option v-for="(item,index) in areas.addressCities" :value="index">{{item.name}}</option>

              </select>
              <select class="form_select s_w120" disabled name="" v-model="userInfo.user.address_district">
                <option value="">区</option>
                <option v-for="(item,index) in areas.addressDistrict" :value="index">{{item.name}}</option>

              </select>
            </div>
            <div class="auto_flex">
              <input class=" form_input time_icon w100" disabled type="text" v-model="userInfo.user.address_detail"/>
            </div>

          </div>

        </div>
      </div>
    </div>


    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>2014年9月30日前人事信息
    </h3>
    <!-- 标题 end-->
    <div class="fill_group_row clearfix w_half">
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>改革时人员类别</label>
        <div class="form_control w_auto ">
          <select class="i_w300 form_select time_icon" disabled @change="getPositionInfo" v-model="userInfo.special.type">
            <option value="1">事业单位专业技术人员</option>
            <option value="2">事业单位管理人员</option>
            <option value="3">事业单位工人</option>
          </select>
        </div>
      </div>
    </div>

    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>参保信息
    </h3>
    <!-- 标题 end-->
    <div class="clearfix">
      <div class="fill_group_row clearfix fl w_half">
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>参保日期</label>
          <div class="form_control w_auto ">
            <vue-datepicker-local class="i_w300 form_input date_picker_out" disabled v-model='userInfo.insurance.insured_time' name="ins_date"></vue-datepicker-local>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>编制类型</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select" disabled v-model='userInfo.insurance.compilation_type'>
              <option value="1">事业</option>
            </select>
          </div>
        </div>
      </div>
      <div class="fill_group_row clearfix fr w_half">

        <div class="form_group clearfix">
          <label class="control_label ">首次参保年月</label>
          <div class="form_control w_auto ">
            <vue-datepicker-local class="i_w300 form_input date_picker_out" disabled v-model='userInfo.insurance.first_insured_time' name="first_ins_date"></vue-datepicker-local>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label ">账户建立年月</label>
          <div class="form_control w_auto ">
            <vue-datepicker-local class="i_w300 form_input date_picker_out" disabled v-model='userInfo.insurance.account_creation_time' name="build_date"></vue-datepicker-local>
          </div>
        </div>
      </div>
    </div>


    <h3 class="form_title clearfix"><span>| </span>工资申报信息
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th v-for="tableTittle in tableTittles">{{tableTittle}}</th>
        </tr>
        <template v-for="(item,index) in mPaymentList">
          <tr v-if="!item.flag">
            <td>{{item.year}}</td>
            <td>{{item.wages_pay}}</td>
            <td>{{item.base_pay}}</td>
            <td>{{item.start_time}}</td>
            <td>{{item.end_time}}</td>
            <td><span @click="delItem(index)" style="cursor: pointer;">删除</span></td>

          </tr>
          <tr v-else>
            <td><input class = 'i_w145 form_input mr10' min="1"  type="number" v-model="item.year"><span style="font-size: 12px;visibility: hidden">保留两位小数点</span></td>
            <td><input class = 'i_w145 form_input mr10' min="1"  type="number" v-on:blur="getBase(item,index)" v-model="item.wages_pay"><span style="font-size: 12px">保留两位小数点</span></td>
            <td><input class = 'i_w145 form_input mr10' min="1"  type="number" v-model="item.base_pay"><span style="font-size: 12px;visibility: hidden">保留两位小数点</span></td>
            <!--<td><vue-datepicker-local class="i_w150 form_input date_picker_out" v-model='item.start_time'></vue-datepicker-local><span style="font-size: 12px;visibility: hidden">数点</span></td>-->
            <td><input class="i_w145 form_input mr10" placeholder="xxxx/xx/xx" type="text" v-model="item.start_time"  /><span style="font-size: 12px;visibility: hidden">数点</span></td>
            <!--<td><vue-datepicker-local class="i_w150 form_input date_picker_out" v-model='item.end_time'></vue-datepicker-local><span style="font-size: 12px;visibility: hidden">数点</span></td>-->
            <td><input class="i_w145 form_input mr10" placeholder="xxxx/xx/xx" type="text" v-model="item.end_time"  /><span style="font-size: 12px;visibility: hidden">数点</span></td>
            <td>
              <span @click="cancelAdd(index)" style="cursor: pointer; margin-right: 10px">取消</span>
              <span @click="complete(index)" style="cursor: pointer;">完成</span>
            </td>
          </tr>
          <!--"-->
        </template>

        <tr v-show="showAdd">
          <td colspan="6" @click="addPaymentItem" style="cursor: pointer;">添加记录</td>
          <!---->
        </tr>

      </table>
    </div>

    <h3 class="form_title clearfix"><span>| </span>计算补收信息
    </h3>
    <div style="margin-bottom: 30px;overflow: auto;">
      <table class="table" >
        <tr>
          <th v-for="tableSupple in tableSupples">{{tableSupple}}</th>
        </tr>
        <tr v-for="(item,index) in  SuppleList.list   ">
          <td>{{item.mouth}}</td>
          <td>{{item.wages_pay}}</td>
          <td>{{item.base_pay}}</td>
          <td>{{item.type}}</td>
          <td>{{Number(item.company_pay).toFixed(2)}}</td>
          <td>{{Number(item.person_pay).toFixed(2)}}</td>
          <td>{{Number(item.total_pay).toFixed(2)}}</td>
        </tr>
        <tr >
          <td class="td_border" colspan='4'>总计：</td>
          <td>{{Number(SuppleList.total_company_pay).toFixed(2)}}</b></td>
          <td>{{Number(SuppleList.total_person_pay).toFixed(2)}}</b></td>
          <td>{{Number(SuppleList.total_pay).toFixed(2)}}</b></td>
        </tr>
      </table>
      <!--<loading v-show="loading"></loading>-->
      <Pagination :total="listcount" :pagesize="pagesize" :pagegroup="pagegroup" @pagechange="pagechange"></Pagination>
    </div>
    <div style="margin-bottom: 30px; ">
      <table class="table" >
        <tr>
          <th v-for="tableSupple in tableSupples">{{tableSupple}}</th>
        </tr>
        <tr v-for="(item,index) in  PensionDetailList.list   ">
          <td>{{item.mouth}}</td>
          <td>{{item.wages_pay}}</td>
          <td>{{item.base_pay}}</td>
          <td>{{item.type}}</td>
          <td>{{Number(item.company_pay).toFixed(2)}}</td>
          <td>{{Number(item.person_pay).toFixed(2)}}</td>
          <td>{{Number(item.total_pay).toFixed(2)}}</td>
        </tr>
        <tr >
          <td class="td_border" colspan='4' >总计：</td>
          <td>{{Number(PensionDetailList.total_company_pay).toFixed(2)}}</td>
          <td>{{Number(PensionDetailList.total_person_pay).toFixed(2)}}</td>
          <td>{{Number(PensionDetailList.total_pay).toFixed(2)}}</td>
        </tr>
      </table>
      <Pagination :total="PenListcount" :pagesize="pagesize" :pagegroup="pagegroup" @pagechange="penPagechange"></Pagination>
    </div>


    <h3 class="form_title clearfix"><span>| </span>操作记录
    </h3>
    <div class="history_info_box">
      <div class="line_box"></div>
      <div class="history_info clearfix" v-for="(item,index) in userInfo.log">
        <div class="history_left">
          <p>{{item.create_time.split(' ')[0]}}</p>
          <p>{{item.create_time.split(' ')[1]}}</p>
        </div>
        <div class="history_right">
          <p class="history_info_tit"><i class="blue_dot"></i><span>{{item.operator_name}}</span></p>
          <p>操作类型：{{item.type==1?'基本更新':item.type==2?'转退休':'转离职'}}</p>
        </div>
      </div>
    </div>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
    <msgTips v-show="showFlag" @confirm="layerConfirm" @cancel="layerCancel" title="提示">
      <p class="layer_content">确认要删除【{{userInfo.user.username}}】的员工信息？删除后不可找回，请谨慎操作</p>
    </msgTips>
    <msgTips v-show="showMflag" @confirm="mLayerConfirm(mIndex)" @cancel="mlayerCancel" title="提示">
      <p class="layer_content">确认要删除该条月缴费记录？删除后不可找回，请谨慎操作</p>
    </msgTips>
  </div>
</template>
<script>
  import VueDatepickerLocal from 'vue-datepicker-local'
  import locations from '../../libs/location_libs'
  import axios from 'axios'
  import qs from 'qs'
  import toastTips from '../../components/layer/toastTips'
  import msgTips from '../../components/layer/msgTips'
  import Pagination from '../../libs/pagination'
  import moment from 'moment'
  import index from "../../router";
  // import loading from '../../libs/loading'

  export default {
    name:'workerSee',
    components:{
      VueDatepickerLocal,
      toastTips,
      msgTips,
      Pagination,
      // loading
    },
    data(){
      return {
        tableTittles:['年度','缴费工资','缴费基数','开始年月','终止年月','操作'],
        tableSupples:['年度','缴费工资','缴费基数','险种类型','单位应缴金额','个人应缴金额','总金额'],
        areas:{
          allArr:locations.locations,
          domicileCities:'',
          addressDistrict:'',
          domicileDistrict:'',
          addressCities:''
        },
        listcount:0,
        PenListcount:0,
        pagesize:15,
        pagegroup:7,
        pageNo:1,
        penPageNo:1,
        loading:true,
        report_province:'',
        report_city:'',
        report_area:'',
        toast:false,
        showFlag:false,
        toastContent:'',
        companyData:[],
        SuppleList:{},
        PensionDetailList:{},
        id:this.$route.params.id,
        userInfo:{
          user:{
            username:'',
            idcard:'',
            social_security_account:'',
            type:'',
            sex:1,
            nation:'',
            birthday:'',
            work_time:'',
            mobile:'',
            telephone:'',
            domicile_province:'',
            domicile_city:'',
            domicile_district:'',
            domicile_detail:'',
            company_id:'',
            work_unit_name:'',
            address_province:'',
            address_city:'',
            address_district:'',
            address_detail:'',
            postal_code:''
          },
          special:{
            type:''
          },
          insurance:{
            insured_time:'',
            first_insured_time:'',
            compilation_type:1,
            account_creation_time:''
          }
        },
        positionInfo:{},
        mPaymentList:[],
        showMflag:false,
        mIndex:'',
        showAdd:true
      }
    },
    methods:{
      pagechange:function(currentpage){
        this.pageNo=currentpage;
          this.getSupplelist();
      },
      penPagechange:function(currentpage){
        this.penPageNo=currentpage;
          this.getPensionDetail();
      },
      updateCity:function(cities,province){
        this.areas[cities] =this.areas.allArr[province].sub
      },
      updateDistrict:function(district,cities,province){
        this.areas[district] =this.areas.allArr[province].sub[cities].sub
      },
      gotoOther:function(type){
        if(type=='retire'){
          this.$router.push({name:'add',params:{type:'retire',index:'1',status:'edit',id:this.id},query:{isFromWorker:true}});
        }else{
          this.$router.push({name:'add',params:{type:'leaver',index:'2',status:'edit',id:this.id},query:{isFromWorker:true}});
        }
      },

      getSupplelist:function () {
        var that=this;
        axios.get('/user/getMPaymentDetail',{
            params:{
              user_id:that.id,
              page:that.pageNo,
              page_num:15
            }
        }
        ).then((response)=>{
          if(response.data.code==22000){
            if(response.data.result){
              that.SuppleList = response.data.result
              that.listcount =response.data.result.total
            }else{
              that.SuppleList = {};
            }

          }else if(response.data.code !== 22000){
            that.SuppleList = {};
            console.log(response.data.message)
          }
        })
      },
      getPensionDetail:function () {
        var that=this;
        axios.get('/user/getPensionDetail',{
            params:{
              user_id:that.id,
              page:that.penPageNo,
              page_num:15
            }
        }
        ).then((response)=>{
          if(response.data.code==22000){
            if(response.data.result){
              that.PensionDetailList = response.data.result
              that.PenListcount =response.data.result.total
            }else{
              that.PensionDetailList = {};
            }

          }else if(response.data.code !== 22000){
            that.PensionDetailList = {};
            console.log(response.data.message)
          }
        })
      },

      getBase:function (item,index) {
        console.log(item)
        let that=this;
        // let lastItem=that.mPaymentList[that.mPaymentList.length-1];
        axios.get('/averageSalary/getYearInfo',{
            params:{
              year:item.year
            }
          }
        ).then((response)=>{
          if(response.data.code==22000){
            let diffValue1 = Number(item.wages_pay)-Number(response.data.result.payment_base_highest)
            let diffValue2 = Number(item.wages_pay)-Number(response.data.result.payment_base_lowest)
            if( diffValue1 >=  0 ){
              this.$set(this.mPaymentList,index ,item)
              let paymentBaseHighest=response.data.result.payment_base_highest
              item.base_pay = paymentBaseHighest
            }else if (diffValue2 <=  0){
              this.$set(this.mPaymentList,index ,item)
              item.base_pay = response.data.result.payment_base_lowest
            }else{
              this.$set(this.mPaymentList,index ,item)
              let wagesPay = Math.round(item.wages_pay*0.1)*10
              item.base_pay = wagesPay

            }
          }else if(response.data.code !== 22000){

          }
        })


      },

      delPerson:function(){
        this.showFlag=true;
      },
      layerCancel:function(){
        this.showFlag=false;
      },
      layerConfirm:function(){
        var that=this,
          tipBox = document.getElementsByClassName('tipsBox')[0];
        that.showFlag=false;
        axios.post('/user/delete',qs.stringify(
          {
            id:that.id,
            type:1
          }
        )).then((response)=>{
          if(response.data.code==22000){
            that.toastContent='删除成功';
            tipBox.style.display='block';
            setTimeout(function(){
              tipBox.style.display='none';
              window.location.href='/#/list/0';
            },3000);
          }else if(response.data.code == 50001){
            window.location.href='/#/login';
          }else{
            that.toastContent='操作失败';
            tipBox.style.display='block';
            setTimeout(function(){
              tipBox.style.display='none';
            },3000);
          }
        })
      },
      getPositionInfo:function(){
        var that=this;
        axios.get('/config/getPersonnelTypeRank',{
            type:userInfo.special.type
        }).then((response)=>{
          if(response.data.code == 22000){
            that.positionInfo = response.data.result;
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }
        })
      },
      getMPaymentList:function(){
        var that=this;
        axios.get('/user/getMPaymentList',{
          params:{
            user_id:that.id
          }
        }).then((response)=>{
          if(response.data.code==22000){
            that.mPaymentList=response.data.result
          }
        })
      },
      addPaymentItem:function(){
        var that=this;
        this.mPaymentList.push({
          flag:true,
          start_time:'',
          end_time:'',
          payment_base:'',
          user_id:that.id

        });
        // this.showAdd=false
      },
      delItem:function(index){
        this.showMflag=true;
        this.mIndex=index;
      },
      mlayerCancel:function(){
        this.showMflag=false
      },
      mLayerConfirm:function(index){
        var that=this;
        // that.getSupplelist();
        // than.getPensionDetail();
        // console.log(index);
        axios.post('/user/delMPayment',qs.stringify({
          id:that.mPaymentList[index].id
        })).then((response)=>{
          if(response.data.code==22000){
            that.mPaymentList.splice(index,1);
            that.showMflag=false;
            this.getSupplelist();
            this.getPensionDetail();
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        });

      },
      complete:function(index){
        var that=this,
            lastItem=that.mPaymentList[that.mPaymentList.length-1];
            // lastItem.base_pay=lastItem.payment_base;
        if(!lastItem.start_time || !lastItem.end_time || !lastItem.base_pay|| !lastItem.wages_pay|| !lastItem.year){
          that.toast=true;
          that.toastContent='请填写信息';
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000);
          this.showAdd=true;
          return false;
        }

        lastItem.start_time =  moment(lastItem.start_time).format("YYYY-MM-DD")
        lastItem.end_time =  moment(lastItem.end_time).format("YYYY-MM-DD")
        axios.post('/user/addMPayment',qs.stringify(
          lastItem
        )).then((response)=>{
          if(response.data.code==22000){
            this.$set(that.mPaymentList[index],"flag",false);
            this.showAdd=true;
            this.getMPaymentList();
            this.getSupplelist();
            this.getPensionDetail();
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.mPaymentList.pop();
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000);
            this.showAdd=true;
          }
        })
      },




      cancelAdd:function(index){
        this.mPaymentList.splice(index,1);
        this.showAdd=true;
        this.getSupplelist();
        this.getPensionDetail();
      }

    },
    mounted:function(){
      var that=this;
      axios.get('/admin/company/list',{

        }).then((response)=>{
          if(response.data.code == 22000){
          that.companyData = response.data.result.list;
        }else if(response.data.code==50001){
          window.location.href='/#/login'
        }else{
          that.toast=true;
          that.toastContent=response.data.message;
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000)
        }
      });
      axios.get('/user/getInfo',{
        params:{
          id:that.id
        }
      }).then((response)=>{
        if(response.data.code==22000) {
          var result = response.data.result;
          for(var key in result){
            for(var item in result[key]){
              if(typeof(result[key][item])=='string' && result[key][item].indexOf('-')>0
                && result[key][item].split('-')[0]=='0000'){
                result[key][item]='';
              }
            }
          }
          that.userInfo=result;
//          that.userInfo=response.data.result;
          this.getSupplelist();
          this.getPensionDetail();
        }else if(response.data.code == 50001){
          window.location.href='/#/login';
        }
      });
      this.getMPaymentList()
    },
    watch:{
      'userInfo.user.domicile_province' : function(){
        this.updateCity('domicileCities',this.userInfo.user.domicile_province);

      },
      'userInfo.user.address_province' : function(){
        this.updateCity('addressCities',this.userInfo.user.address_province);
      },
      'userInfo.user.domicile_city' : function(){
        this.updateDistrict('domicileDistrict',this.userInfo.user.domicile_city,this.userInfo.user.domicile_province);

      },
      'userInfo.user.address_city' : function(){
        this.updateDistrict('addressDistrict',this.userInfo.user.address_city,this.userInfo.user.address_province);
      }
    }

  }
</script>
<style lang="less" scoped>
  .w_375{
    width: 375px!important;;
  }
  .w100{
    width:85%!important;
  }
  .flex{
    display: flex;
    width:90%;
  }
  .auto_flex{
    flex:.94;
  }
  .table_outer_box{
    margin-bottom: 30px;
  }
  .history_info_box{
    position: relative;
  .line_box{
    position: absolute;
    left: 91px;
    height: 100%;
    border-right: 1px solid #e1e7f6;
  }
  .history_info{
    /*padding-left: 39px;*/
    margin-bottom: 40px;
  .history_left{
    float: left;
    width: auto;
    text-align: right;
  }
  .history_right{
    float: left;
    margin-left: 50px;
  p{
    color: #32363a;
  span{
    color: #32363a;
  }
  .edition_change_info{
    margin-left: 10px;
    color: #aaa;
  }
  }
  .history_info_tit{
    position: relative;
    margin-bottom: 10px;
  .blue_dot{
    position: absolute;
    top:9px;
    left: -6px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #0080ea;
  }
  }
  }
  }
  }
  .date_picker_out{
    padding:0!important;
  input{
    border:none !important;
    width:100%!important;
  }
  }
  .operation_list{
    position:absolute;
    right:20px;
    top:0;
    li{
      cursor: pointer;
      padding-left: 30px;
      margin-left: 22px;
      line-height: 50px;
    }
  }
  .layer_content{
    text-align: center;
    line-height: 80px;
    font-size: 16px;
  }
  .table{
    .td_border{
      text-align: center;
    }
    .td_border_b{
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/seeList/workerSee.vue